import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const loadSalesforceAccountId = (website: string) =>
  createGenericDispatcher<{ salesforceAccountId: string | null }>({
    name: 'LOAD_SALESFORCE_ACCOUNT',
    loadFunction: () => Api.get(`/salesforce?website=${website}`),
    args: {},
  });
